import React, { FC } from "react";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { UserItem } from "shared/api";
import { userInitials } from "./utils";

const OverviewThisWeekTaskAssigneeAvatar: FC<{ user: UserItem | null }> = ({
  user,
}) => {
  if (user?.image) {
    return (
      <Avatar
        size={36}
        className="shrink-0"
        src={user.image}
        alt={user.username}
      />
    );
  }
  if (user) {
    return (
      <span
        title={user.username}
        aria-label={user.username}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-semibold leading-none tabular-nums text-[#334155]"
        style={{ backgroundColor: "#cbd5e1" }}
      >
        {userInitials(user)}
      </span>
    );
  }
  return (
    <span
      aria-hidden
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#e2e8f0] text-[#64748b] text-[15px] leading-none [&_.anticon]:leading-none [&_svg]:inline-block [&_svg]:shrink-0"
    >
      <UserOutlined />
    </span>
  );
};

export { OverviewThisWeekTaskAssigneeAvatar };
